import React, { useMemo } from 'react';
import PickingProgressInfoTable from './PickingProgressInfoTable/PickingProgressInfoTable';
import { PickingProgressInfoData } from './PickingProgressInfoTable/PickingProgressInfoTableTypes';
import { Row, Title } from '@ydistri/ds';
import RateTag from '../RateTag/RateTag';
import { PickingProgressStatisticsResponse } from '@ydistri/api-sdk';

interface RoutesPickingProgressInfoProps {
  routesPickingProgress: PickingProgressStatisticsResponse;
  pickingProgressRate: number;
  showInProgress: boolean;
}

const RoutesPickingProgressInfo: React.FC<RoutesPickingProgressInfoProps> = ({
  routesPickingProgress,
  pickingProgressRate,
  showInProgress,
}) => {
  const tableData = useMemo((): PickingProgressInfoData[] => {
    const columns: PickingProgressInfoData[] = [
      {
        label: 'Not started',
        value: routesPickingProgress.notStartedCount,
        description: 'Have not started picking yet.',
      },
    ];

    if (showInProgress) {
      columns.push({
        label: 'In progress',
        value: routesPickingProgress.inProgressCount,
        description: 'Picking has started but not finished yet.',
      });
    }

    columns.push(
      {
        label: 'Finished',
        value: routesPickingProgress.finishedCount,
        description: 'Picking is finished.',
        divider: true,
      },
      {
        label: 'Total',
        value: routesPickingProgress.totalCount,
        isTotal: true,
      },
    );

    return columns;
  }, [
    routesPickingProgress.finishedCount,
    routesPickingProgress.inProgressCount,
    routesPickingProgress.notStartedCount,
    routesPickingProgress.totalCount,
    showInProgress,
  ]);

  const titleComponent = useMemo(() => {
    return (
      <Row $justifyContent="space-between" $minHeight="2rem">
        <Title $size="small">Routes</Title>
        <RateTag value={pickingProgressRate} title="Total picking progress rate" />
      </Row>
    );
  }, [pickingProgressRate]);

  return (
    <PickingProgressInfoTable
      id="routesPickingProgressInfo"
      title={titleComponent}
      data={tableData}
    />
  );
};

export default RoutesPickingProgressInfo;
